var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pui-tooltip"),
      !_vm.units.length
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger text-center",
              attrs: { role: "alert" },
            },
            [_c("h2", [_vm._v(_vm._s(_vm.$t("pleaseChangePlant")))])]
          )
        : _c(
            "pui-grid-container",
            { staticClass: "msp-wrapper-container" },
            [
              _c(
                "pui-grid-row",
                [
                  _c(
                    "pui-grid-column",
                    [
                      _c("RecycleScroller", {
                        attrs: {
                          items: _vm.unitsData,
                          "item-size": null,
                          "size-field": "size",
                          "key-field": "sid",
                          "page-mode": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("overview-unit", {
                                  key: item.sid,
                                  attrs: { unit: item },
                                  on: {
                                    emitHeightChanged: _vm.handleHeight,
                                    collapsed: _vm.handleCollapsed,
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }